import { Injectable, inject } from '@angular/core';

import { UsersService } from '@app/services/users.service';

@Injectable({ providedIn: 'root' })
export class LogoutFirstGuard {
    private readonly usersService = inject(UsersService);

    async canActivate() {
        await this.usersService.logout(true);
        return true;
    }
}
